export default {
  errorsRootKey: 'promts-ai.fields',
  resource: 'accounts/:accountId/promts-ai',

  index(accountId, params = {}, options = {}) {
    const resourceUrl = this.resource.replace(':accountId', accountId)
    return Vue.http.get(resourceUrl, {params, ...options})
      .then(response => response.data)
  },

  show(accountId, id, options = {}) {
    const resourceUrl = this.resource.replace(':accountId', accountId)
    return Vue.http.get(`${resourceUrl}/${id}`, options)
      .then(response => response.data.data)
  },

  create(accountId, data = {}, options = {}) {
    const resourceUrl = this.resource.replace(':accountId', accountId)
    return Vue.http.post(resourceUrl, data, {errorsRootKey: this.errorsRootKey, ...options})
      .then(
        response => response.data,
        response => { throw response.data.errors }
      )
  },

  update(accountId, id, data = {}, options = {}) {
    const resourceUrl = this.resource.replace(':accountId', accountId)
    return Vue.http.put(`${resourceUrl}/${id}`, data, {errorsRootKey: this.errorsRootKey, ...options})
      .then(
        response => response.data,
        response => { throw response.data.errors }
      )
  },

  destroy(accountId, id, options = {}) {
    const resourceUrl = this.resource.replace(':accountId', accountId)
    return Vue.http.delete(`${resourceUrl}/${id}`, options)
  }
}
